import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { getOrderItemReviews, getReviewsByUserId } from 'Redux/ducks/user-review';
import { sendConfirmEmail, checkConfirmed } from 'Redux/ducks/auth';
import OrderItemReviews from 'Components/ProductReviews/OrderItemReviews/OrderItemReviews';
import attachReviewsToItems from 'Helpers/Order/OrderItemReviewHelper';

const messages = defineMessages({
  title: {
    id: 'accountuserreviewscontainer.yourproductreviews',
    defaultMessage: 'Your Product Reviews',
  },
});

const OrderItemReviewsContainer = ({
  intl: { formatMessage },
  authenticated,
  email,
  emailConfirmed,
  failedCheck,
  sendConfirmEmail: _sendConfirmEmail,
  checkConfirmed: _checkConfirmed,
  isAdmin,
}) => {
  const [items, setItems] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const _items = await getOrderItemReviews();
        const _reviews = await getReviewsByUserId();
        const orderItemReviews = attachReviewsToItems(_items, _reviews);
        setItems(orderItemReviews);
      } catch (e) {
        setFetchError(true);
      }
      setHasLoaded(true);
    };
    fetchItems();
  }, [authenticated]);

  if (!authenticated) {
    return (
      <section className="account-content">
        <h1>
          <FormattedMessage id="orderitemreviewscontainer.unauthenticated" defaultMessage="Sign in to view your product reviews" />
        </h1>
      </section>
    );
  }

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <OrderItemReviews
        items={items}
        setItems={setItems}
        hasLoaded={hasLoaded}
        fetchError={fetchError}
        sendConfirmEmail={_sendConfirmEmail}
        checkConfirmed={_checkConfirmed}
        email={email}
        emailConfirmed={emailConfirmed}
        failedCheck={failedCheck}
        isAdmin={isAdmin}
      />
    </React.Fragment>
  );
};

const mapStateToProps = ({
  auth: {
    email,
    email_confirmed: emailConfirmed,
    sentEmail,
    failed_check: failedCheck,
    authenticated,
    role,
  },
  orders: { one },
}) => ({
  email,
  emailConfirmed,
  sentEmail,
  failedCheck,
  order: one,
  authenticated,
  isAdmin: role === 'admin',
});

const mapDispatchToProps = {
  sendConfirmEmail,
  checkConfirmed,
};

OrderItemReviewsContainer.propTypes = {
  email: PropTypes.string,
  emailConfirmed: PropTypes.bool.isRequired,
  failedCheck: PropTypes.bool,
  sendConfirmEmail: PropTypes.func.isRequired,
  checkConfirmed: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  isAdmin: PropTypes.bool,
};

OrderItemReviewsContainer.defaultProps = {
  email: '',
  authenticated: false,
  failedCheck: undefined,
  isAdmin: false,
};

export default connect(mapStateToProps,
  mapDispatchToProps)(injectIntl(OrderItemReviewsContainer));
